<section>
  @if (form) {
    <header class="mb-24">
      <div class="flex items-center justify-end space-x-2">
        <app-audio-assets [assets]="form.controls.assets" />
        <p-button
          icon="pi pi-sparkles"
          label="Generate"
          appThrottleClick
          [throttleTime]="500"
          (throttleClick)="onAssembleClick()"
          [disabled]="isAssembleButtonDisable" />
        <p-button
          outlined
          icon="pi pi-sync"
          label="Restart"
          (onClick)="onRestartClick($event)" />
        @if (hasChanges) {
          <p-button
            icon="pi pi-save"
            label="Save"
            [disabled]="isAnySegmentAssetGenerating"
            appThrottleClick
            [throttleTime]="500"
            (throttleClick)="onSaveClick()"></p-button>
          <p-button
            icon="pi pi-undo"
            label="Reset"
            severity="warn"
            (onClick)="onResetClick($event)"></p-button>
        }
      </div>
    </header>
    @if (form.controls.segments.controls.length) {
      <ul class="space-y-6">
        @for (
          segment of form.controls.segments.controls;
          track segment.controls.$key.value
        ) {
          <li>
            <app-audio-segment
              [session]="session"
              [idea]="idea"
              [segment]="segment"
              (segmentAdd)="onSegmentAddClick(segment)"
              (segmentDelete)="onSegmentDeleteClick(segment)"
              (segmentReset)="onSegmentResetClick(segment)" />
          </li>
        }
      </ul>
    } @else {
      <div class="flex items-center justify-center">
        <p-button
          rounded
          outlined
          icon="pi pi-plus"
          severity="info"
          label="Start manually"
          (onClick)="onSegmentAddClick()" />
      </div>
    }
  } @else if (idea.phoneticScript) {
    <header>
      <div class="flex items-center justify-end space-x-2">
        <p-button
          icon="pi pi-plus"
          label="Create"
          appThrottleClick
          [throttleTime]="500"
          (throttleClick)="onCreateClick()" />
      </div>
    </header>
  }
</section>
